import React from 'react';
import Col from 'react-bootstrap/Col';

const PhoneTemplate = ({ mt15, isBrowserCol12, phoneTypes, telefono, isBrowserMt }) => {
    const formatPhoneNumber = (phone) => {
        
        let phoneFormatted = "";
        if (phone.length == 10) { 
            phoneFormatted = `(${phone.substring(0,3)}) ${phone.substring(3,6)}-${phone.substring(6,10)}`
        } else {
            phoneFormatted = phone
        }
        return phoneFormatted;
    }
    return (
        <>
            <Col style={mt15} xs={isBrowserCol12}>
                <strong> 
                    Teléfono {' '}
                    <span style={{textTransform: 'lowercase'}}> 
                        { 
                            phoneTypes.length > 0 && 
                            phoneTypes.find(x => x.id == telefono.telefonoTipoId).nombre 
                        } 
                    </span>
                </strong>
            </Col>
            <Col style={isBrowserMt} xs={isBrowserCol12}>
                { formatPhoneNumber(telefono.numero) }
            </Col>
        </>
    );
};

export default (PhoneTemplate);